// Vendors
import { requestHasSuccessStatus } from '@openbank/cf-ui-framework';
// Utilities
import { logCustomActionService } from 'services/log.service';

const logCustomActionResolver = async (description: string): Promise<[boolean]> => {
  const [, { status }] = await logCustomActionService(description);

  return [requestHasSuccessStatus(status)];
};

export { logCustomActionResolver };
